export const designSystemColors = {
  cedar: 'rgba(64, 83, 69, 1)',
  cedarShade: 'rgba(44, 58, 47, 1)',
  cedarTint: 'rgba(89, 112, 94, 1)',
  charcoal: 'rgba(35, 33, 33, 1)',
  coolGray: 'rgba(233, 233, 233, 1)',
  lake: 'rgba(156, 209, 239, 1)',
  lakePop: 'rgba(252, 252, 126, 1)',
  lakeShade: 'rgba(111, 148, 170, 1)',
  lakeTint: 'rgba(209, 234, 248, 1)',
  lavender: 'rgba(145, 118, 209, 1)',
  lavenderLight: 'rgba(236, 223, 255, 1)',
  lavenderMidTint: 'rgba(181, 163, 224, 1)',
  lavenderShade: 'rgba(103, 84, 148, 1)',
  lavenderTint: 'rgba(204, 192, 234, 1)',
  lemon: 'rgba(252, 252, 126, 1)',
  lightSand: 'rgba(255, 252, 249, 1)',
  ocean: 'rgba(0, 80, 119, 1)',
  poppy: 'rgba(249, 99, 83, 1)',
  poppy06: 'rgba(177, 70, 59, 1)',
  poppyLight: 'rgba(249, 193, 185, 1)',
  poppyMidTint: 'rgba(251, 150, 140, 1)',
  poppyShade: 'rgba( 177, 70, 59, 1)',
  poppyTint: 'rgba(255, 183, 176, 1)',
  sage: 'rgba(116, 74, 110, 1)',
  sageLight: 'rgba(191, 172, 240, 1)',
  sageMidTint: 'rgba(162, 134, 158, 1)',
  sageShade: 'rgba(64, 41, 61, 1)',
  sageTint: 'rgba(191, 172, 188, 1)',
  sageTint2: 'rgba(191, 172, 188, 1)',
  sand: 'rgba(255, 252, 249, 1)',
  sandShade: 'rgba(233, 220, 198, 1)',
  sandTint: 'rgba(249, 246, 240, 1)',
  storm: 'rgba(109, 119, 126, 1)',
  stormShade: 'rgba(66, 72, 76, 1)',
  stormTint: 'rgba(175, 175, 175, 1)',
  transparent: 'transparent',
  warningBrown: 'rgba(98, 41, 10, 1)',
  warningYellow: 'rgba(238, 164, 88, 1)',
  white: 'rgba(255, 255, 255, 1)',
  poppyMid: 'rgba(251, 150, 140, 1)',
  charcoalTint: 'rgba(154, 153, 153, 1)',
  charcoalMid: 'rgba(108, 106, 106, 1)',
  charcoalShade:'rgba(25, 23,23, 1)',
  cotton: 'rgba(255, 252, 249, 1)',
  cottonShade: 'rgba(233, 220, 198, 1)',
  cottonMid: 'rgba(244, 237, 226, 1)',
  cottonTint: 'rgba(249, 246, 240, 1)',
  violet: 'rgba(145, 118, 209, 1)',
  violetMid: 'rgba(181, 163, 224, 1)',
  violetShade: 'rgba(103, 84, 148, 1)',
  violetTint: 'rgba(204, 192, 234, 1)',
  yellow: 'rgba(252, 252, 126, 1)',
  yellowTint: 'rgba(254, 254, 196, 1)',
  yellowMid: 'rgba(253, 253, 169, 1)',
  yellowShade: 'rgba(229, 229, 115, 1)',
  sky: 'rgba(156, 209, 239, 1)',
  skyShade: 'rgba(111, 148, 170, 1)',
  skyMid: 'rgba(189, 224, 244, 1)',
  skyTint: 'rgba(209, 234, 248, 1)',
  orange: 'rgba(255, 164, 62, 1)',
  orangeTint: 'rgba(255, 213, 166, 1)',
  orangeMid: 'rgba(255, 194, 126, 1)',
  orangeShade: 'rgba(181, 116, 44, 1)',
  pink: 'rgba(241, 192, 242, 1)',
  pinkTint: 'rgba(249, 226, 249, 1)',
  pinkMid:'rgba(244, 205, 245, 1)',
  pinkShade: 'rgba(171, 136, 172, 1)',
  eggplant: 'rgba(116, 74, 110, 1)',
  eggplantShade: 'rgba(64, 41, 61, 1)',
  eggplantTint: 'rgba(191, 172, 188, 1)',
  eggplantMid: 'rgba(162, 134, 158, 1)',
  stone: 'rgba(219, 212, 204, 1)',
  stoneShade: 'rgba(155 ,151, 145, 1)',
  stoneTint: 'rgba(238, 235, 232, 1)',
  stoneMid: 'rgba(231, 226, 221, 1)',
} as const;

export type DesignSystemColorTypes = keyof typeof designSystemColors;

export type TNamedBackgroundColors = 'dark' | 'light' | 'charcoal' | 'lightSand' | 'white';

export type TDesignSystemColors = {
  cedar?: 'rgba(64, 83, 69, 1)';
  cedarShade?: 'rgba(44, 58, 47, 1)';
  cedarTint?: 'rgba(89, 112, 94, 1)';
  charcoal?: 'rgba(35, 33, 33, 1)';
  coolGray?: 'rgba(233, 233, 233, 1)';
  lake?: 'rgba(156, 209, 239, 1)';
  lakePop?: 'rgba(252, 252, 126, 1)';
  lakeShade?: 'rgba(111, 148, 170, 1)';
  lakeTint?: 'rgba(209, 234, 248, 1)';
  lavender?: 'rgba(145, 118, 209, 1)';
  lavenderLight?: 'rgba(236, 223, 255, 1)';
  lavenderMidTint?: 'rgba(181, 163, 224, 1)';
  lavenderShade?: 'rgba(103, 84, 148, 1)';
  lavenderTint?: 'rgba(204, 192, 234, 1)';
  lemon?: 'rgba(252, 252, 126, 1)';
  lightSand?: 'rgba(255, 252, 249, 1)';
  ocean?: 'rgba(0, 80, 119, 1)';
  poppy?: 'rgba(249, 99, 83, 1)';
  poppy06?: 'rgba(177, 70, 59, 1)';
  poppyLight?: 'rgba(249, 193, 185, 1)';
  poppyMidTint?: 'rgba(251, 150, 140, 1)';
  poppyShade?: 'rgba( 177, 70, 59, 1)';
  poppyTint?: 'rgba(255, 183, 176, 1)';
  sage?: 'rgba(116, 74, 110, 1)';
  sageLight?: 'rgba(191, 172, 240, 1)';
  sageMidTint?: 'rgba(162, 134, 158, 1)';
  sageShade?: 'rgba(64, 41, 61, 1)';
  sageTint?: 'rgba(191, 172, 188, 1)';
  sageTint2?: 'rgba(191, 172, 188, 1)';
  sand?: 'rgba(255, 252, 249, 1)';
  sandShade?: 'rgba(233, 220, 198, 1)';
  sandTint?: 'rgba(249, 246, 240, 1)';
  storm?: 'rgba(109, 119, 126, 1)';
  stormShade?: 'rgba(66, 72, 76, 1)';
  stormTint?: 'rgba(175, 175, 175, 1)';
  transparent?: 'transparent';
  white?: 'rgba(255, 255, 255, 1)';
  poppyMid?: 'rgba(251, 150, 140, 1)';
  charcoalTint?: 'rgba(154, 153, 153, 1)';
  charcoalMid?: 'rgba(108, 106, 106, 1)';
  charcoalShade?: 'rgba(25, 23,23, 1)';
  cotton?: 'rgba(255, 252, 249, 1)';
  cottonShade?: 'rgba(233, 220, 198, 1)';
  cottonMid?: 'rgba(244, 237, 226, 1)';
  cottonTint?: 'rgba(249, 246, 240, 1)';
  violet?: 'rgba(145, 118, 209, 1)';
  violetMid?: 'rgba(181, 163, 224, 1)';
  violetShade?: 'rgba(103, 84, 148, 1)';
  violetTint?: 'rgba(204, 192, 234, 1)';
  yellow?: 'rgba(252, 252, 126, 1)';
  yellowTint?: 'rgba(254, 254, 196, 1)';
  yellowMid?: 'rgba(253, 253, 169, 1)';
  yellowShade?: 'rgba(229, 229, 115, 1)';
  sky?: 'rgba(156, 209, 239, 1)';
  skyShade?: 'rgba(111, 148, 170, 1)';
  skyMid?: 'rgba(189, 224, 244, 1)';
  skyTint?: 'rgba(209, 234, 248, 1)';
  orange?: 'rgba(255, 164, 62, 1)';
  orangeTint?: 'rgba(255, 213, 166, 1)';
  orangeMid?: 'rgba(255, 194, 126, 1)';
  orangeShade?: 'rgba(181, 116, 44, 1)';
  pink?: 'rgba(241, 192, 242, 1)';
  pinkTint?: 'rgba(249, 226, 249, 1)';
  pinkMid?: 'rgba(244, 205, 245, 1)';
  pinkShade?: 'rgba(171, 136, 172, 1)';
  eggplant?: 'rgba(116, 74, 110, 1)';
  eggplantShade?: 'rgba(64, 41, 61, 1)';
  eggplantTint?: 'rgba(191, 172, 188, 1)';
  eggplantMid?: 'rgba(162, 134, 158, 1)';
  stone?: 'rgba(219, 212, 204, 1)';
  stoneShade?: 'rgba(155 ,151, 145, 1)';
  stoneTint?: 'rgba(238, 235, 232, 1)';
  stoneMid?: 'rgba(231, 226, 221, 1)';
};

export const otherColors = {
  accordionBorderGray: 'rgb(205 206 206)',
  charcoal20: 'rgba(35, 36, 38, 0.20)',
  charcoal50: 'rgba(136, 141, 146, 1)',
  ghostActiveGray: 'rgba(237, 237, 237, 1)',
  navBorderGray: 'rgba(35, 36, 38, .2)',
  navDescriptionGray: 'rgba(130, 130, 130, 1)',
  gray40: 'rgba(223, 227, 230, 1)',
  gray50: 'rgba(223, 227, 230, 0.5)',
  gray70: 'rgba(145, 151, 159, 1)',
  gray90: 'rgba(79, 82, 86, 1)',
  inputFieldBackground: 'rgba(62, 59, 55, 1)',
  inputFieldBoxShadow: 'rgba(16, 24, 40, 0.05)',
  inputText: 'rgba(55, 63, 71, 1)',
  archiveCardBoxShadow: 'rgba(16, 24, 40, 0.1)',
  neutral500: 'rgba(107, 114, 128, 1)',
  neutral900: 'rgba(17, 24, 39, 1)',
  placeholderText: 'rgba(185, 185, 185, 1)',
  fadedCharcoal: 'rgba(35, 36, 38, 0.1)',
  fadedCharcoal15: 'rgba(35, 36, 38, 0.15)',
  fadedCharcoal20: 'rgba(35, 36, 38, 0.2)',
  fadedWhite: 'rgba(255, 255, 255, 0.1)',
  fadedWhite20: 'rgba(255, 255, 255, 0.2)',
  checkBoxHoverBackground: 'rgba(255, 255, 255, 0.2)',
  playButtonBackground: 'rgba(0, 0, 0, 0.5)',
  errorRed: 'rgba(239, 68, 68, 1)',
  relatedContentCardDarkBorder: 'rgba(255, 255, 255, 0.2)',
  lightBorder: 'rgba(35, 36, 38, 0.2)',
  darkBorder: 'rgba(255, 255, 255, 0.2)',
  background: designSystemColors.white,
  logo: designSystemColors.charcoal,
  text: designSystemColors.charcoal,
  // klaviyo one colors
  accordionBorderCedar: 'rgba(44, 58, 47, .2)',
  accordionBorderWhite: 'rgba(255, 255, 255, .2)',
  fadedCedar: 'rgba(64, 83, 69, 0.1)',
  fadedCedarShade: 'rgba(44, 58, 47, 0.1)',
  // inputFieldBackground: 'rgba(242, 244, 245, 1)',
  inputPlaceholderText: 'rgba(44, 58, 47, 0.5)',
  navigationBorder: 'rgba(64, 83, 69, .1)',
  shadowColor: 'rgba(0, 0, 0, 0.11)',
} as const;

export type TCoreColors = 
  'charcoal'  | 
  'coolGray' |
  'cotton' |
  'eggplant' |
  'orange' |
  'pink' |
  'poppy' |
  'sky' |
  'stone' |
  'violet' |
  'yellow' |
  'white' |
  'transparent';

export type OtherColorTypes = keyof typeof otherColors;

